import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent'
import { logger } from 'src/utils/logger.utils'
import { getNewRelicWarning } from './NewRelic.helper'
import type { StartNewRelicParameter } from './NewRelic.types'

export function startNewRelic({
  accountID,
  trustKey,
  agentID,
  licenseKey,
  applicationID,
  beacon,
  errorBeacon,
  sa,
  allowedOrigins,
  corsUseNewrelicHeader,
  corsUseTraceContextHeaders,
}: StartNewRelicParameter) {
  const distributedTracing = {
    enabled: true,
    cors_use_newrelic_header: corsUseNewrelicHeader,
    cors_use_tracecontext_headers: corsUseTraceContextHeaders,
    allowed_origins: allowedOrigins,
  }
  const denyList = ['bam.eu01.nr-data.net']
  const options = {
    init: {
      distributed_tracing: distributedTracing,
      privacy: { cookies_enabled: true },
      ajax: { deny_list: denyList },
      allow_url_fragments: true,
    },
    info: { beacon, errorBeacon, licenseKey, applicationID, sa },
    loader_config: { accountID, trustKey, agentID, licenseKey, applicationID },
  }

  new BrowserAgent(options)
}

export function initNewRelic(startNewRelicParameter: StartNewRelicParameter) {
  const warningMessage = getNewRelicWarning(startNewRelicParameter)
  if (warningMessage === '') {
    startNewRelic(startNewRelicParameter)
  } else {
    logger.warn(`NewRelic configuration : ${warningMessage}`)
  }
}
